import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import CustomSections from '../components/CustomSections';
import Community from '../components/Community';
import Newsletter from '../components/Newsletter';
import GalleryTeaser from '../components/GalleryTeaser';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import About from '../components/About';
import Program from '../components/Program';
import Activities from '../components/Activities';
import CTA from '../components/CTA';
import Speakers from '../components/Speakers';
import Venues from '../components/Venues';
import Worship from '../components/Worship';
import LocationMap from '../components/LocationMap';
import Sponsors from '../components/Sponsors';
import SocialButtons from '../components/SocialButtons';
import Footer from '../components/Footer';
import VideoPromo from '../components/VideoPromo';
import ReviewsPreview from '../components/ReviewsPreview';
import SocialFeed from '../components/SocialFeed';
import { Seo } from '../components/Seo';
import LoginNudge from '../components/LoginNudge';
import { useContent } from '../context/ContentContext';
import { DEFAULT_SITE_CONTENT, SITE_CONTENT_SCHEMA } from '../components/admin/SiteContentEditor';
import { SchemaEditor } from '../components/admin/SchemaEditor';

const Landing = ({ adminPreview = false }) => {
  const { content } = useContent();
  const site = content.site || {};
  const { hash } = useLocation();
  const [editingFields, setEditingFields] = React.useState(null);

  useEffect(() => {
    if (!hash) return;
    const timer = setTimeout(() => document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: 'smooth' }), 150);
    return () => clearTimeout(timer);
  }, [hash]);

  const editClickedField = (event) => {
    const target = event.target instanceof Element ? event.target.closest('[data-edit-fields]') : null;
    if (!adminPreview || !target) return;
    event.preventDefault();
    event.stopPropagation();
    setEditingFields(target.dataset.editFields.split(',').filter(Boolean));
  };

  return (
    <div className="App bg-black min-h-screen text-white antialiased" data-testid={adminPreview ? 'admin-site-preview' : 'public-landing-page'} onClickCapture={adminPreview ? editClickedField : undefined}>
      {adminPreview && (
        <div className="relative z-[70] flex flex-wrap items-center justify-between gap-2 bg-[#ffb400] px-4 py-2 text-sm font-bold text-black">
          <span>ADMINMODUS · Klikk på tekst, logo eller bilete, eller bruk Rediger-knappane</span>
          <div className="flex items-center gap-4">
            <Link to="/admin" className="underline underline-offset-2">Adminpanel</Link>
            <Link to="/" className="underline underline-offset-2">Offentleg visning</Link>
          </div>
        </div>
      )}
      <Seo
        title={site.seoTitle || 'Refuel Weekend 2027 | Offisiell nettside'}
        description={site.seoDescription || 'Refuel Weekend 2027 – ungdomshelg i Hjeltefjorden Arena, Øygarden, 2.–4. april 2027. Program, talarar, aktivitetar, overnatting og påmelding. Offisiell nettside for Refuel Weekend.'}
        path={adminPreview ? '/admin_console' : '/'}
        noindex={adminPreview}
      />
      <Navbar />
      <main>
        <Hero />
        <VideoPromo />
        <About />
        <Program />
        <Activities />
        <CustomSections />
        <CTA />
        <Speakers />
        <Venues />
        <GalleryTeaser />
        <Worship />
        <LocationMap />
        <SocialFeed />
        <SocialButtons />
        <Sponsors />
        <ReviewsPreview />
        <Newsletter />
        <Community />
        <LoginNudge />
      </main>
      <Footer />
      {editingFields && <SchemaEditor contentKey="site" title="Rediger valgt innhald" initial={{ ...DEFAULT_SITE_CONTENT, ...(content.site || {}) }} schema={SITE_CONTENT_SCHEMA.filter((field) => editingFields.includes(field.key))} single onClose={() => setEditingFields(null)} />}
    </div>
  );
};

export default Landing;